export function WaitlistPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <div className="bg-card border-border max-w-md space-y-4 rounded-md border p-8 text-center">
        <p className="text-muted-foreground text-xs uppercase tracking-widest">
          SUPER
        </p>
        <h1 className="text-2xl font-semibold">Thanks for signing up.</h1>
        <p className="text-muted-foreground text-sm">
          Your account is created. Someone from Super will reach out to get you
          onboarded — you don't need to do anything else right now.
        </p>
        <p className="text-muted-foreground text-xs">
          Questions?{' '}
          <a className="underline" href="mailto:hello@hiresuper.com">
            hello@hiresuper.com
          </a>
        </p>
      </div>
    </div>
  )
}
